// extracted by mini-css-extract-plugin
export default {"error":"MultiSelectDropdown_error__RbXYF"};